import clsx from "clsx";
import React from "react";

function Button({ text, onClick, className, disabled, style }) {
  return (
    <div>
      <button
        style={style}
        disabled={disabled}
        onClick={onClick}
        className={clsx(
          className,
          "flex items-center justify-center w-full shadow-lg shadow-sky-300 active_gradient text-white font-medium rounded-3xl py-[0.7rem]",
          disabled ? "opacity-60" : "opacity-100",
        )}
      >
        {text}
      </button>
    </div>
  );
}

export default Button;
